import {
  FormGroupLabel,
  FormRadioGroup,
  useDialogContext,
} from "@ariakit/react";
import { Unit } from "../../domain/unit";
import { atomic } from "../atomic.css";
import { useDatabase } from "../database-provider";
import { FormDialog } from "../form-dialog";
import { useForm } from "../hooks/use-form";
import { CheckboxField } from "../checkbox-field";

export function UnitAbilitiesDialog(props: { unit: Unit }) {
  const { unit } = props;
  const db = useDatabase();
  const store = useDialogContext();

  const form = useForm({
    defaultValues: {
      abilityIds: unit.abilities.map((a) => a.id),
    },
    async onSubmit(values) {
      await db.updateArmy({
        ...unit.army.data,
        units: unit.army.data.units.map((u) => {
          if (u.id === unit.data.id) {
            const abilities = values.abilityIds.map((id) => ({ id }));
            return { ...u, abilities };
          }

          return u;
        }),
      });

      store?.hide();
    },
  });

  return (
    <FormDialog form={form} heading="Abilities" submitLabel="Save">
      <FormRadioGroup>
        <FormGroupLabel
          className={atomic({
            borderBlockEnd: "solid",
            paddingBlockEnd: 6,
            fontWeight: "medium",
          })}
        >
          Unit abilities
        </FormGroupLabel>

        {Array.from(props.unit.ruleset.abilityDefs.values()).map((def) => {
          return (
            <div
              key={def.id}
              className={atomic({
                borderBlockEnd: "dashed",
              })}
            >
              <div
                className={atomic({
                  display: "grid",
                  gridTemplateColumns: "fraction-auto",
                  paddingBlock: 16,
                  fontFamily: "arboria",
                  fontWeight: "black",
                  fontStyle: "italic",
                })}
              >
                <CheckboxField
                  label={def.name}
                  name={form.names.abilityIds}
                  value={def.id}
                />
                <span>
                  {def.unit_cost === 0 ? "Free" : `${def.unit_cost}pts`}
                </span>
              </div>

              <div
                className={atomic({
                  fontSize: 14,
                  paddingBlockEnd: 16,
                  lineHeight: 1.5,
                })}
              >
                {def.description}
              </div>
            </div>
          );
        })}
      </FormRadioGroup>
    </FormDialog>
  );
}
